import { State } from 'common/interfaces/state';
import { store } from '../../store';
import { BaseResourcesApi } from './base-resource-api';

const getBaseUrl = (): string => {
  const state: State = store.getState();
  const companyId = state.account.selectedCompany && state.account.selectedCompany.id;
  const subscriptionType = state.account.selectedSubscriptionType;

  if (!companyId) {
    console.error('CompanyResourcesApi: company id is empty');
  }

  if (!subscriptionType) {
    console.error('CompanyResourcesApi: subscriptionType is empty');
  }

  return `/company/${companyId}/${subscriptionType}`;
};

export const CompanyResourcesApi = new BaseResourcesApi(getBaseUrl);
